export const FETCH_PAYMENT_TOKEN_REQUEST = "FETCH_PAYMENT_TOKEN_REQUEST";
export const FETCH_PAYMENT_TOKEN_SUCCESS = "FETCH_PAYMENT_TOKEN_SUCCESS";
export const FETCH_PAYMENT_TOKEN_FAILURE = "FETCH_PAYMENT_TOKEN_FAILURE";

export const MAKE_PAYMENT_REQUEST = "MAKE_PAYMENT_REQUEST";
export const MAKE_PAYMENT_SUCCESS = "MAKE_PAYMENT_SUCCESS";
export const MAKE_PAYMENT_FAILURE = "MAKE_PAYMENT_FAILURE";

export const FETCH_PAYMENT_HISTORY_REQUEST = "FETCH_PAYMENT_HISTORY_REQUEST";
export const FETCH_PAYMENT_HISTORY_SUCCESS = "FETCH_PAYMENT_HISTORY_SUCCESS";
export const FETCH_PAYMENT_HISTORY_FAILURE = "FETCH_PAYMENT_HISTORY_FAILURE";

export const DELETE_CARD_REQUEST = "DELETE_CARD_REQUEST";
export const DELETE_CARD_SUCCESS = "DELETE_CARD_SUCCESS";
export const DELETE_CARD_FAILURE = "DELETE_CARD_FAILURE";
